import { render } from "./Queue.vue?vue&type=template&id=277c8d2f&scoped=true"
import script from "./Queue.vue?vue&type=script&lang=js"
export * from "./Queue.vue?vue&type=script&lang=js"

import "./Queue.vue?vue&type=style&index=0&id=277c8d2f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-277c8d2f"

export default script